export class AppUserModel {
    public subscriberId :string;
    public firstName : string;
    public lastName : string;   
    public profilePictureUrl : string;
    public email : string;
    public phone : string;
    public dateOfBirth : any;
    public city:string;
    public country: string;
    public active : boolean;
   
}